module.exports = __webpack_public_path__ + "static/media/club-feast.326974e3.png";